import { SelectOption } from "global";
import { Attachment, EquipmentFormValue } from "../types";

export const equipmentAttachment: Attachment = {
  model: "",
  type: "Body",
  unitCost: 0,
  category: "Truck",
  manufacturer: "",
  quantityPerAsset: 1,
};

export const formDefaultValue: EquipmentFormValue = {
  commonInfo: {
    vin: "",
    year: "",
    make: "",
    model: "",
    class: null,
    quality: null,
    mileage: null,
    saleCost: 0,
    stockId: "",
    condition: "",
    description: "",
    retailPrice: 0,
    wholeSaleCost: 0,
  },
  attachments: [],
};

export const invoiceLevelOptionForQuote = [{ label: "Invoice", value: null }] as any as SelectOption[];
